import { useHistory } from "react-router";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PATH_TRIPS } from "../../utils/urlPaths";
import styles from "./styles.module.scss";

export const RyanairCallbackConfirmation = () => {
  const { t } = useI18nContext();
  const history = useHistory();

  const handleViewTrips = () => {
    history.push(PATH_TRIPS);
  };

  return (
    <div className={styles.RyanairCallbackConfirmation}>
      <h1 className={styles.title}>{t("ryanairConfirmation.title")}</h1>
      <h2 className={styles.heading}>{t("ryanairConfirmation.heading")}</h2>
      <div className={styles.body}>
        <p>{t("ryanairConfirmation.bodyLine1")}</p>
        <p>{t("ryanairConfirmation.bodyLine2")}</p>
      </div>
      <button className={styles.button} onClick={handleViewTrips} type="button">
        {t("ryanairConfirmation.viewTripButton")}
      </button>
    </div>
  );
};
